import { MutationTree } from 'vuex';

import {
  FilesStateI,
  FilesResultI,
  FileI,
  SearchResultI,
} from './state';

export const mutations: MutationTree<FilesStateI> = {

  setResult(state: FilesStateI, payload: FilesResultI) {
    state.result.page = payload.page;
    state.result.perPage = payload.perPage;
    state.result.totalPages = payload.totalPages;

    if (payload.page > 1) {
      state.result.total += payload.total; // operador += recomendado por ESLint

      // evitar for...of prohibido por no-restricted-syntax
      state.result.data = [...state.result.data, ...payload.data];
    } else {
      state.result.total = payload.total;
      state.result.data = payload.data || [];
    }
  },

  setUploadProgress(state: FilesStateI, payload: number) {
    state.uploadProgress = payload;
  },

  setFile(state: FilesStateI, payload: FileI) {
    state.file = payload;
  },

  setSearchResult(state: FilesStateI, payload: SearchResultI) {
    console.log('payload', payload);
    state.searchResult = payload;
  },

  setSelectedFiles(state: FilesStateI, payload: FileI[]) {
    state.selectedFiles = payload;
  },

  clearUploadFiles(state: FilesStateI) {
    state.uploadFiles = [];
  },
  setActivePreviewFile(state: FilesStateI, payload: FileI | null) {
    state.activePreviewFile = payload;
  },
  setPreviewFilesList(state: FilesStateI, payload: FileI[]) {
    state.previewFilesList = payload;
  },
  setActiveInfoFile(state: FilesStateI, payload: FileI | null) {
    state.activeInfoFile = payload;
  },
  setActiveShareFile(state: FilesStateI, payload: FileI | null) {
    state.activeShareFile = payload;
  },
};
